import React, { useEffect, useRef, useState } from "react";
import { AppSettings } from "./config/app-settings.js";
import { slideToggle } from "./composables/slideToggle.js";

import Header from "./components/header/header.jsx";
import Sidebar from "./components/sidebar/sidebar.jsx";
import SidebarRight from "./components/sidebar-right/sidebar-right.jsx";
import TopMenu from "./components/top-menu/top-menu.jsx";
import Content from "./components/content/content.jsx";
import { history } from "./_helpers/history.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions, facilityAction, masterActions } from "./_store";
// import ThemePanel from "./components/theme-panel/theme-panel.jsx";
import Footer from "./components/Footer.jsx";
import PreventBackNavigation from "./_helpers/PreventBackNavigation.jsx";
import ScrollableCard from "./components/common/ScrollableCard.jsx";
import TabTracker from "./_helpers/tabMonitor.js";
import Swal from "sweetalert2";
import { showToastNotification } from "./components/common/ui/NotificationModal/ToastNotication.js";
import { SignalRProvider } from "./hooks/SignalRService.jsx";
import { getStoredValue, removeStoredValue, setStoredValue } from "./_helpers/storagehelper.js";

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();
  const dispatch = useDispatch();
  const [appTheme] = useState("");
  const [appDarkMode, setAppDarkMode] = useState(false);
  const [appGradientEnabled, setAppGradientEnabled] = useState(false);
  const [appHeaderNone, setAppHeaderNone] = useState(false);
  const [appHeaderFixed, setAppHeaderFixed] = useState(true);
  const [appHeaderInverse, setAppHeaderInverse] = useState(false);
  const [appHeaderMegaMenu, setAppHeaderMegaMenu] = useState(false);
  const [appHeaderLanguageBar, setAppHeaderLanguageBar] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const [appSidebarNone, setAppSidebarNone] = useState(false);
  const [appSidebarWide, setAppSidebarWide] = useState(false);
  const [appSidebarLight, setAppSidebarLight] = useState(false);
  const [appSidebarMinify, setAppSidebarMinify] = useState(false);
  const [appSidebarMobileToggled, setAppSidebarMobileToggled] = useState(false);
  const [appSidebarTransparent, setAppSidebarTransparent] = useState(false);
  const [appSidebarSearch, setAppSidebarSearch] = useState(false);
  const [appSidebarFixed, setAppSidebarFixed] = useState(true);
  const [appSidebarGrid, setAppSidebarGrid] = useState(false);
  const [appContentNone, setAppContentNone] = useState(false);
  const [appContentClass, setAppContentClass] = useState("");
  const [appContentFullHeight, setAppContentFullHeight] = useState(false);
  const [appTopMenu, setAppTopMenu] = useState(false);
  const [appTopMenuMobileToggled] = useState(false);
  const [appSidebarTwo, setAppSidebarTwo] = useState(false);
  const [appSidebarEnd, setAppSidebarEnd] = useState(false);
  const [appSidebarEndToggled, setAppSidebarEndToggled] = useState(false);
  const [appSidebarEndMobileToggled, setAppSidebarEndMobileToggled] =
    useState(false);
  const [timer, setTimer] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Assuming the user starts as authenticated
  const menuList = getStoredValue("menu_list") || [];
  const sessionTimeout = process.env.REACT_APP_SESSION_TIMEOUT; //15 minutes

  const maintenanceData = useSelector(
    (x) => x?.master?.applicationSettingsData
  );

  const handleSetAppHeaderNone = (value) => {
    setAppHeaderNone(value);
  };

  const handleSetAppHeaderInverse = (value) => {
    setAppHeaderInverse(value);
  };

  const handleSetAppHeaderLanguageBar = (value) => {
    setAppHeaderLanguageBar(value);
  };

  const handleSetAppHeaderMegaMenu = (value) => {
    setAppHeaderMegaMenu(value);
  };

  const handleSetAppHeaderFixed = (value) => {
    if (value === false && appSidebarFixed) {
      alert(
        "Default Header with Fixed Sidebar option is not supported. Proceed with Default Header with Default Sidebar."
      );
      setAppSidebarFixed(false);
      if (localStorage) {
        localStorage.appSidebarFixed = false;
      }
    }
    setAppHeaderFixed(value);
    if (localStorage) {
      localStorage.appHeaderFixed = value;
    }
  };

  const handleSetAppSidebarNone = (value) => {
    setAppSidebarNone(value);
  };

  const handleSetAppSidebarWide = (value) => {
    setAppSidebarWide(value);
  };

  const handleSetAppSidebarLight = (value) => {
    setAppSidebarLight(value);
  };

  const handleSetAppSidebarMinified = (value) => {
    setAppSidebarMinify(value);
  };

  const handleSetAppSidebarTransparent = (value) => {
    setAppSidebarTransparent(value);
  };

  const handleSetAppSidebarSearch = (value) => {
    setAppSidebarSearch(value);
  };

  const handleSetAppSidebarFixed = (value) => {
    if (value === true && !appHeaderFixed) {
      alert(
        "Default Header with Fixed Sidebar option is not supported. Proceed with Fixed Header with Fixed Sidebar."
      );
      setAppHeaderFixed(true);
      if (localStorage) {
        localStorage.appHeaderFixed = true;
      }
    }
    setAppSidebarFixed(value);
    if (localStorage) {
      localStorage.appSidebarFixed = value;
    }
  };

  const handleSetAppSidebarGrid = (value) => {
    setAppSidebarGrid(value);
    if (localStorage) {
      localStorage.appSidebarGrid = value;
    }
  };

  const toggleAppSidebarMinify = (e) => {
    e.preventDefault();
    setAppSidebarMinify(!appSidebarMinify);
    if (localStorage) {
      localStorage.appSidebarMinify = !appSidebarMinify;
    }
  };

  const toggleAppSidebarMobile = (e) => {
    e.preventDefault();
    setAppSidebarMobileToggled(!appSidebarMobileToggled);
  };

  const handleSetAppSidebarEnd = (value) => {
    setAppSidebarEnd(value);
  };

  const handleSetAppContentNone = (value) => {
    setAppContentNone(value);
  };

  const handleSetAppContentClass = (value) => {
    setAppContentClass(value);
  };

  const handleSetAppContentFullHeight = (value) => {
    setAppContentFullHeight(value);
  };

  const handleSetAppTopMenu = (value) => {
    setAppTopMenu(value);
  };

  const toggleAppTopMenuMobile = (e) => {
    e.preventDefault();
    slideToggle(document.querySelector(".app-top-menu"));
  };

  const handleSetAppSidebarTwo = (value) => {
    setAppSidebarTwo(value);
    setAppSidebarEndToggled(value);
  };

  const handleSetAppBoxedLayout = (value) => {
    if (value === true) {
      document.body.classList.add("boxed-layout");
    } else {
      document.body.classList.remove("boxed-layout");
    }
  };

  const handleSetAppDarkMode = (value) => {
    if (value === true) {
      document.querySelector("html").setAttribute("data-bs-theme", "dark");
    } else {
      document.querySelector("html").removeAttribute("data-bs-theme");
    }
    setAppDarkMode(value);
    if (localStorage) {
      localStorage.appDarkMode = value;
    }
    document.dispatchEvent(new Event("theme-reload"));
  };

  const handleSetAppGradientEnabled = (value) => {
    setAppGradientEnabled(value);
    if (localStorage) {
      localStorage.appGradientEnabled = value;
    }
  };

  const handleSetAppTheme = (value) => {
    var newTheme = "theme-" + value;
    for (var x = 0; x < document.body.classList.length; x++) {
      if (
        document.body.classList[x].indexOf("theme-") > -1 &&
        document.body.classList[x] !== newTheme
      ) {
        document.body.classList.remove(document.body.classList[x]);
      }
    }
    document.body.classList.add(newTheme);

    if (localStorage && value) {
      localStorage.appTheme = value;
    }
    document.dispatchEvent(new Event("theme-reload"));
  };

  const toggleAppSidebarEnd = (e) => {
    e.preventDefault();
    setAppSidebarEndToggled(!appSidebarEndToggled);
  };

  const toggleAppSidebarEndMobile = (e) => {
    e.preventDefault();
    setAppSidebarEndMobileToggled(!appSidebarEndMobileToggled);
  };

  useEffect(() => {
    handleSetAppTheme(appTheme);
    if (appDarkMode) {
      handleSetAppDarkMode(true);
    }

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
      var elm = document.getElementsByClassName("nvtooltip");
      for (var i = 0; i < elm.length; i++) {
        elm[i].classList.add("d-none");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [appTheme, appDarkMode]);

  //Admin - Session expire issue When we close the working tab and enter the URL again it should be redirected to login page
  //  const previousPage = document.referrer;

  //  window.onload = function () {
  //    //localStorage.setItem("IsPageLoad", "true");
  //    sessionStorage.setItem("IsPageLoad", "true");

  //  };
  //  if (performance.getEntriesByType("navigation")[0].type === "reload") {
  //    localStorage.setItem("auth", "true");
  //  }

  //  if (previousPage.length == 0 && sessionStorage.getItem("IsPageLoad") === "true") {
  //    localStorage.setItem("auth", "true");
  //  }

  //  if (localStorage.getItem("auth") === "false") {

  //    dispatch(authActions.logout());
  //  }

  //  let shouldWarn = true;

  //  window.addEventListener("beforeunload", function (e) {
  //    if (shouldWarn) {
  //      localStorage.setItem("auth", "false");
  //      localStorage.setItem("IsPageLoad", "false");
  //      // These two lines are required in Chrome to show the prompt
  //      e.preventDefault();
  //      e.returnValue = ''; // This triggers the default confirmation dialog
  //    }
  //  });

  // Admin - Session expire issue

  // const resetTimer = () => {
  //   if (timer) clearTimeout(timer);
  //   const newTimer = setTimeout(
  //     () => dispatch(authActions.logout()),
  //     sessionTimeout
  //   );
  //   setTimer(newTimer);
  // };

  // useEffect(() => {
  //   const events = ["mousemove", "keydown", "mousedown", "touchstart"];
  //   events.forEach((event) => window.addEventListener(event, resetTimer));
  //   resetTimer();
  //   return () => {
  //     if (timer) clearTimeout(timer);
  //     events.forEach((event) => window.removeEventListener(event, resetTimer));
  //   };
  // }, []);


  // Enable Right Click Option in Admin
  // useEffect(() => {
  //   // Block right-click to prevent the context menu
  //   const handleRightClick = (e) => {
  //     e.preventDefault(); // Prevent the context menu on right-click
  //   };

  //   // Restrict new tab opening by overriding window.open()
  //   const originalWindowOpen = window.open;
  //   window.open = (url, target, features) => {
  //     // Block new tab/window opening if target is '_blank' or if it's a different URL
  //     if (target === "_blank" || (url && url !== window.location.href)) {
  //       // alert('Opening new tabs or windows is blocked!');
  //       return null; // Prevent the new tab from opening
  //     }
  //     return originalWindowOpen(url, target, features);
  //   };

  //   // Prevent opening new tabs from links with target="_blank"
  //   const handleLinkClick = (e) => {
  //     if (
  //       e.target.tagName === "A" &&
  //       e.target.getAttribute("target") === "_blank"
  //     ) {
  //       e.preventDefault(); // Prevent opening the link in a new tab
  //       //alert('Opening links in new tabs is blocked!');
  //       return null;
  //     }
  //   };

  //   // Prevent middle mouse button click from opening links in a new tab
  //   const handleMiddleClick = (e) => {
  //     if (e.button === 1) {
  //       // 1 corresponds to the middle mouse button
  //       e.preventDefault(); // Prevent opening the link in a new tab
  //       alert("Middle-click (scroll button) to open in a new tab is blocked!");
  //       return null;
  //     }
  //   };

  //   // Clear localStorage when the tab/window is closed
  //   const incrementTabCount = () => {
  //     const currentTabCount = Number(localStorage.getItem("tabCount") || 0);
  //     localStorage.setItem("tabCount", currentTabCount + 1);
  //   };

  //   // Handle when the tab is being closed (or window is closed)
  //   const handleBeforeUnload = () => {
  //     const currentTabCount = Number(localStorage.getItem("tabCount") || 1);
  //     if (currentTabCount > 1) {
  //       // If it's the last tab, clear localStorage
  //       localStorage.clear();
  //     } else {
  //       // Decrement the tab count
  //       localStorage.setItem("tabCount", currentTabCount - 1);
  //     }
  //   };

  //   // Initialize the tab counter if it’s a new session or first tab
  //   //incrementTabCount();

  //   // Add event listeners
  //   document.addEventListener("contextmenu", handleRightClick); // Block right-click
  //   document.addEventListener("click", handleLinkClick); // Prevent links with target="_blank"
  //   document.addEventListener("mousedown", handleMiddleClick); // Prevent middle-click (scroll button)
  //   // window.addEventListener('beforeunload', handleBeforeUnload); // Clear localStorage on tab close

  //   // Clean up event listeners on component unmount
  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick);
  //     document.removeEventListener("click", handleLinkClick);
  //     document.removeEventListener("mousedown", handleMiddleClick);
  //     // window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);


  useEffect(() => {
    let sessionTimer;
    const handleSessionExpiration = () => {
      setIsAuthenticated(false); // Update the authentication status
      // You might want to redirect the user to a login page or perform other actions
      Swal.close();
      dispatch(authActions.logout({}));
      dispatch(facilityAction.resetFacilitySearch());
    };

    // Set a timer for session expiration (e.g., 15 minutes)
    // Retrieve session timeout from environment variable or use a default value

    const sessionTimeout = process.env.REACT_APP_SESSION_TIMEOUT; // 15 * 60 * 1000; // 15 minutes in milliseconds
    // Reset the timer on user activity (e.g., mousemove, keydown)
    const resetSessionTimer = () => {
      clearTimeout(sessionTimer);
      sessionTimer = setTimeout(
        handleSessionExpiration,
        parseInt(sessionTimeout)
      );
    };

    // Attach event listeners for user activity
    window.addEventListener("mousemove", resetSessionTimer);
    window.addEventListener("keydown", resetSessionTimer);

    // Set up the initial session timer
    resetSessionTimer();

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("mousemove", resetSessionTimer);
      window.removeEventListener("keydown", resetSessionTimer);
      clearTimeout(sessionTimer);
    };
  }, [isAuthenticated]);

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://cdn.jsdelivr.net/npm/eruda";
  //   script.onload = () => {
  //     window.eruda && window.eruda.init();
  //   };
  //   document.body.appendChild(script);
  // }, []);

  /* For Maintanence */
  /* If user get any Action need to Redirect Maintenance Page */
  useEffect(() => {
    const events = ["click"];
    events.forEach((event) => window.addEventListener(event, handleUserAction));
    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserAction)
      );
    };
  }, [maintenanceData]);

  useEffect(() => {
    handleUserAction();
  }, []);

  const handleCheckLogin = () => {
    const isLoggedIn = getStoredValue("isLoggedIn");
    if (!isLoggedIn) {
      removeStoredValue("menu_list");
      removeStoredValue("filter_menu_list");
      removeStoredValue("user");
      removeStoredValue("facilityDropDown");
      removeStoredValue("commonFacilityCode");
      // setStoredValue("isLoggedIn", false); 
      removeStoredValue("appSidebarMinify");
      sessionStorage.clear(); window.location.reload();
    }
  }


  const handleUserAction = () => {
    handleCheckLogin();
    dispatch(masterActions.MaintenanceMode("WEB"))
      .then((result) => {
        const data = result?.payload;
        // const data = { IsApplicationMaintenance: 1 };
        if (
          Object?.keys(data).length === 0 ||
          data?.IsApplicationMaintenance === 0
        )
          return;
        /* clear localstorage data */
        dispatch(authActions?.updateUser({}));
        dispatch(authActions?.updateMenuList([]));
        dispatch(authActions?.updateCommonFacilityCode(0));
        removeStoredValue("menu_list");
        removeStoredValue("user");
        removeStoredValue("facilityDropDown");
        removeStoredValue("commonFacilityCode");
        setStoredValue("isLoggedIn", false);
        history.navigate("/Admin/Maintenance");
      })
      .catch((err) => {
        console.error(err?.message);
        // showToastNotification("Failed to fetch maintenance data", "error");
      });
  };

  return (
    <SignalRProvider>
      <AppSettings.Provider
        value={{
          appTheme,
          appDarkMode,
          appGradientEnabled,
          appHeaderNone,
          appHeaderFixed,
          appHeaderInverse,
          appHeaderMegaMenu,
          appHeaderLanguageBar,
          hasScroll,
          handleSetAppHeaderNone,
          handleSetAppHeaderInverse,
          handleSetAppHeaderLanguageBar,
          handleSetAppHeaderMegaMenu,
          handleSetAppHeaderFixed,
          appSidebarNone,
          appSidebarWide,
          appSidebarLight,
          appSidebarMinify,
          appSidebarMobileToggled,
          appSidebarTransparent,
          appSidebarSearch,
          appSidebarFixed,
          appSidebarGrid,
          handleSetAppSidebarNone,
          handleSetAppSidebarWide,
          handleSetAppSidebarLight,
          handleSetAppSidebarMinified,
          handleSetAppSidebarTransparent,
          handleSetAppSidebarSearch,
          handleSetAppSidebarFixed,
          handleSetAppSidebarGrid,
          toggleAppSidebarMinify,
          toggleAppSidebarMobile,
          appContentNone,
          appContentClass,
          appContentFullHeight,
          handleSetAppContentNone,
          handleSetAppContentClass,
          handleSetAppContentFullHeight,
          appTopMenu,
          appTopMenuMobileToggled,
          toggleAppTopMenuMobile,
          handleSetAppTopMenu,
          appSidebarTwo,
          handleSetAppSidebarTwo,
          appSidebarEnd,
          appSidebarEndToggled,
          appSidebarEndMobileToggled,
          toggleAppSidebarEnd,
          toggleAppSidebarEndMobile,
          handleSetAppSidebarEnd,
          handleSetAppBoxedLayout,
          handleSetAppDarkMode,
          handleSetAppGradientEnabled,
          handleSetAppTheme,
        }}
      >
        <ScrollableCard>
          <TabTracker />
          <PreventBackNavigation />
          <div
            className={
              "app " +
              (appGradientEnabled ? "app-gradient-enabled " : "") +
              (appHeaderNone ? "app-without-header " : "") +
              (appHeaderFixed && !appHeaderNone ? "app-header-fixed " : "") +
              (appSidebarFixed ? "app-sidebar-fixed " : "") +
              (appSidebarNone ? "app-without-sidebar " : "") +
              (appSidebarEnd ? "app-with-end-sidebar " : "") +
              (appSidebarWide ? "app-with-wide-sidebar " : "") +
              (appSidebarMinify ? "app-sidebar-minified " : "") +
              (appSidebarMobileToggled ? "app-sidebar-mobile-toggled " : "") +
              (appTopMenu ? "app-with-top-menu " : "") +
              (appContentFullHeight ? "app-content-full-height " : "") +
              (appSidebarTwo ? "app-with-two-sidebar " : "") +
              (appSidebarEndToggled ? "app-sidebar-end-toggled " : "") +
              (appSidebarEndMobileToggled
                ? "app-sidebar-end-mobile-toggled "
                : "") +
              (hasScroll ? "has-scroll " : "")
            }
          >
            {!appHeaderNone && <Header />}
            {!appSidebarNone && menuList?.length > 0 && <Sidebar />}
            {/* {appSidebarTwo && <SidebarRight />} */}
            {/* {appTopMenu && <TopMenu />} */}
            {!appContentNone && <Content />}
            {/* <ThemePanel /> */}
            <Footer />
          </div>
        </ScrollableCard>
      </AppSettings.Provider>
    </SignalRProvider>
  );
}

export default App;
